import { render, staticRenderFns } from "./changePerson.vue?vue&type=template&id=734d3da7&scoped=true&"
import script from "./changePerson.vue?vue&type=script&lang=js&"
export * from "./changePerson.vue?vue&type=script&lang=js&"
import style0 from "./changePerson.vue?vue&type=style&index=0&id=734d3da7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734d3da7",
  null
  
)

export default component.exports